import { createApp, h } from 'vue';
import { IModalManager } from '@/models/modal/modal-manager.interface';
import { ModalManager } from '@studyportals/modal';
import { Rollbar } from '@/models/rollbar.interface';
import App from '@/presentation/app.vue';
import LogIn from '@/stand-alone/log-in/log-in.vue';
import ServiceBlockedModal from '@/presentation/components/shared/service-blocked-modal/service-blocked-modal.vue';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';
import Bootstrapper from '@/bootstrapper';
import StylesheetLoader from '@/stylesheet-loader';
import redshiftTracker from '@/infrastructure/redshift-tracker';
import StatusChecker from '@/infrastructure/status-checker';

const standAloneLogin = webpackDefinitions.STAND_ALONE_LOGIN === 'true';
const url = webpackDefinitions.VUE_APP_ICONSET_URL;

redshiftTracker.prepareForLoadingSpeedTracking();

declare global {
	interface Window {
		ModalManager: IModalManager;
		Rollbar?: Rollbar;
		tinymce: unknown;
	}
}

window.ModalManager = new ModalManager();

StylesheetLoader.loadStylesheet(url);

store.mutations.setStandAloneLogin(standAloneLogin);
const placeholderSelector = '#CampaignEditorFrontendPlaceholder';

// Check service status first
StatusChecker.checkStatus()
	.then((status) => {
		if (StatusChecker.isBlocked(status)) {
			// Service is blocked, show blocking modal
			const app = createApp({
				render: () => {
					return h(ServiceBlockedModal, { reason: status.reason });
				}
			});

			app.mount(placeholderSelector);
		} else {
			// Service is healthy, proceed with normal bootstrap
			return Bootstrapper.bootstrap()
				.then(() => {
					const app = createApp({
						render: () => {
							return h(App);
						}
					});

					rollbarOperator.handleVueErrorsAndWarnings(app);

					app.mount(placeholderSelector);
				})
				.catch((error: Error) => {
					if (!standAloneLogin || error.name !== 'NotAuthorizedException') {
						throw error;
					}

					const app = createApp({
						render: () => {
							return h(LogIn);
						}
					});

					app.mount(placeholderSelector);
				});
		}
	})
	.catch((error: Error) => {
		// If status check fails, log error but proceed with normal bootstrap
		console.error('Failed to check service status:', error);
		
		return Bootstrapper.bootstrap()
			.then(() => {
				const app = createApp({
					render: () => {
						return h(App);
					}
				});

				rollbarOperator.handleVueErrorsAndWarnings(app);

				app.mount(placeholderSelector);
			})
			.catch((bootstrapError: Error) => {
				if (!standAloneLogin || bootstrapError.name !== 'NotAuthorizedException') {
					throw bootstrapError;
				}

				const app = createApp({
					render: () => {
						return h(LogIn);
					}
				});

				app.mount(placeholderSelector);
			});
	});
